<template
  ><v-card class="rounded-t-lg d-flex flex-column" v-bind="$attrs">
    <div v-if="studentInfo" >
      <profileImage class="mb-2"
        classCss="mt-3"
        :size="32"
        :displayName="studentInfo.studentFullName"
        :thumbnail="true"
        :imageUrl="studentInfo.profileImageUrl"
        :to="to"
      />
      <v-divider ></v-divider>
    </div>

    <v-card-title class="pa-0 ma-0 rounded-t-lg d-flex flex-column align-start">
      <v-img v-if="imageLink" :src="imageLink" :height="coverImageHeight" width="100%" class="rounded-t-lg" />

      <v-row class="ma-0 pa-3 px-1" style="width: 100%;">
        <v-col class="ma-0 pa-0" cols="12">
          <div class="d-flex align-start justify-between flex-row   ">
            <div
              :title="title"
              class="wrapped-text text-h6 font-weight-bold mb-0 d-flex flex-row align-center justify-start"
              style="display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;"
            >
              <span v-if="icon" class="d-flex pa-2 info rounded-circle">
                <v-icon color="primary">{{ icon }}</v-icon>
              </span>
              <span
                class="mx-2"
                dir="auto"
                style="font-size: medium;width: 100%; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; width: 100%;"
              >
                {{ title }}
              </span>
            </div>
            <v-spacer></v-spacer>
            <div
              :class="[$vuetify.rtl ? 'ml-auto' : 'mr-auto']"
              style="display: flex;margin-top: 4px;"
            >
              <slot name="header-actions"></slot>
            </div>
          </div>

          <span class="d-flex  flex-row align-center justify-end">
            <slot name="actions"></slot>
          </span>
        </v-col>

        <v-col cols="12" class="py-0">
          <div
            dir="auto"
            :title="description"
            class="text-body-2 "
            style="display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;"
          >
            <span
              style="display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;"
            >
              {{ description }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <slot name="content"></slot>
    <v-spacer></v-spacer>
    <v-card-actions class="d-flex justify-space-between" style="margin-top: auto;">
      <v-btn @click="$emit('details')" color="primary" text>
        {{ $t("portfolio.general.viewDetails") }}
      </v-btn>
      <span>
        <v-btn
          icon
          v-if="showIcons"
          color="primary"
          class="mx-2"
          @click="$emit('edit')"
          :title="$t('edit')"
        >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon v-if="showIcons" color="grey-5" @click="$emit('delete')" :title="$t('delete')">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </span>
    </v-card-actions>
  </v-card>
</template>

<script lang="js">
import profileImage from './profileImage.vue';
export default {
  name: 'BaseCard',
  components: {
    profileImage,
  },
  props: {
    title: String,
    description: String,
    imageLink: String,
    icon: {
      type: String,
      required: false,
    },
    showIcons: {
      type: Boolean,
      default: true,
    },
    symmetricHeight: {
      type: Boolean,
      default: true,
    },
    studentInfo: {
      type: Object,
      default: null
    },
    coverImageHeight: {
      type: String,
      default: '12.5rem',
    },
    to: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

  },
};
</script>

<style scoped>
.wrapped-text {
  word-break: normal;
}
</style>
